import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export type FillConfigMetricInferenceSource = {
  readonly fillName: string;
  readonly fillOrderNumber: number;
  readonly fillColor: string;
  readonly textColor: string;
  readonly btg: BoundaryTerritoryGroup;
};

export type FillConfigMetricInferenceSourceInfo = {
  readonly type: 'FillConfiguration';
  readonly inferenceSources: ReadonlyArray<FillConfigMetricInferenceSource>;
};

export type VirtualMetricInferenceSourceInfo = FillConfigMetricInferenceSourceInfo;

export enum MetricsDataAction {
  SUM = 'sum',
  AVERAGE = 'average',
  HIGH_VALUE = 'high-value',
  LOW_VALUE = 'low-value',
  GROUP_COUNT = 'group-count',
  GROUP_TOTAL = 'group-total',
}

export type MetricProps = Readonly<{
  demographicId?: string;
  additionalData: ReadonlyArray<{
    name: string;
    value: number;
  }>;
  dataAction?: MetricsDataAction;
  secondaryColumnName?: string;
  name: string;
  prefix?: string;
  suffix?: string;
  value: number;
  inferenceSource?: VirtualMetricInferenceSourceInfo;
}>;
